import type { StoryblokPageName } from "config/storyblokPageUuids";

export const REGULAR_PAGES = [
  "cookies", // the only Storyblok page in Regular pages due to Context issues
  "airlineStrikeCompensation",
  "airlines",
  "airports",
  "webapp",
  "webappNewClaim",
  "webappBarcodeScanner",
  "webappBarcodeUploader",
  "ahpBuyEssential",
  "ahpBuyComplete",
  "careers",
] as const;

export type RegularPageName = typeof REGULAR_PAGES[number];

export type PageName = RegularPageName | StoryblokPageName;

export type RegularPageUrls = {
  fallback?: string;
  isExternal?: boolean;
  isMagnitude?: boolean;
  parentLanguageOnly?: boolean;
  [key: string]: string | boolean;
} & ({ passLanguageToUrl: true; baseUrl: string; isExternal: true } | { passLanguageToUrl?: false });
